import { render, staticRenderFns } from "./MemberAdmin.vue?vue&type=template&id=8a639ee8"
import script from "./MemberAdmin.vue?vue&type=script&lang=js"
export * from "./MemberAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports